import iconTimes from 'assets/images/icon-times.svg'
import Loading from 'components/loading'
import ButtonBase from 'components/partials/button'
import InputBase from 'components/partials/inputBase'
import { IDataSearchInput } from 'pages/email-system-management/received-email-text-history/interface'
import React, { useState } from 'react'

interface Props {
  loadingCheckData: boolean
  handleCloseDialog?: (val: boolean) => void
  handleNextBtn?: (applicationNumber: string, carrierBondNumber: string) => void
  dataSearchInput?: IDataSearchInput
}

const CheckDataExistBeforeGenerateJob: React.FC<Props> = ({
  handleCloseDialog = () => null,
  handleNextBtn = () => null,
  loadingCheckData = false,
  dataSearchInput = null,
}) => {
  const classInfoKey = 'text-neutral-3 text-body2 font-semibold leading-6 min-w-[160px]  my-3'

  const [applicationNumber, setApplicationNumber] = useState<string>(
    dataSearchInput?.applicationNumber || '',
  )
  const [carrierBondNumber, setCarrierBondNumber] = useState<string>(
    dataSearchInput?.carrierBondNumber || '',
  )

  const handleApplicationNumberInputChange = (e: any) => {
    setApplicationNumber(e)
  }

  const handleBondNumberInputChange = (e: any) => {
    setCarrierBondNumber(e)
  }

  return (
    <div className="w-full p-1 pr-0">
      <div className="flex flex-col">
        <div className="flex justify-between mb-3">
          <p className="text-headline5">Generate Job</p>
          <img
            src={iconTimes}
            alt=""
            className="cursor-pointer"
            onClick={() => handleCloseDialog(false)}
          />
        </div>
        <p className="mb-3">
          <strong>Step 1</strong>: Check Data By PG Number And Bond Number
        </p>
      </div>
      <div>
        <div className="flex mb-4">
          <div className="w-2/6">
            <p className={classInfoKey}>
              PG Number <span style={{ color: 'red' }}>*</span>
            </p>
          </div>
          <div className="w-4/6">
            <InputBase
              className="w-full"
              placeholder="Enter application number"
              type="text"
              defaultValue={applicationNumber}
              handleChange={(e) => {
                handleApplicationNumberInputChange(e)
              }}
            />
          </div>
        </div>
        <div className="flex mb-4">
          <div className="w-2/6">
            <p className={classInfoKey}>
              Bond Number <span style={{ color: 'red' }}>*</span>
            </p>
          </div>
          <div className="w-4/6">
            <InputBase
              className="w-full"
              placeholder="Enter Bond number"
              type="text"
              defaultValue={carrierBondNumber}
              handleChange={(e) => {
                handleBondNumberInputChange(e)
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <ButtonBase
          type="submit"
          className="w-[150px] my-4 justify-around border-2 border-primary-1"
          onClick={() => handleNextBtn(applicationNumber, carrierBondNumber)}
          disabled={loadingCheckData}
        >
          Next
        </ButtonBase>
        <ButtonBase
          type="submit"
          className="w-[150px] my-4 justify-around border-2 border-primary-1 text-primary-1 bg-white-50 hover:bg-primary-shade4"
          onClick={() => {
            handleCloseDialog(false)
          }}
          bgDisabled="bg-primary-shade3"
        >
          Close
        </ButtonBase>
      </div>
      {loadingCheckData && (
        <Loading
          className="absolute inset-0 flex items-center justify-center bg-gray-500 bg-opacity-70 z-50 rounded-[16px]"
          height={30}
          width={30}
        />
      )}
    </div>
  )
}

export default CheckDataExistBeforeGenerateJob
